<template>
  <div class="container">
    <app-header title="我的足迹"/>
    <div class="recommend-content">
      <van-row gutter="10">
        <van-col span="12" v-for="item in productList" :key='item.pid'>
          <div class="item" @click="toDetailed(item.pid)">
            <img :src="item.img" alt="goods03" width="170" height="170">
            <div class="content">
              <div class="name ellipsis-2">{{item.name}}</div>
              <div class="footer">
                <span class="price">￥{{item.price}}</span>
                <img src="@/assets/mycart.png" alt="加入购物车" width="30" height="30" @click.stop="addCart(item)">
              </div>
            </div>
          </div>
        </van-col>
      </van-row>
      <empty v-if="productList.length==0"/>
    </div>
  </div>
</template>

<script>
import { addShopCart } from '@/api/cart'
import { queryShopTrackList } from '../../../api/track/index.js'
export default {
  name: 'Index',
  data() {
    return {
      value: '',
      productList: []
    }
  },
  created() {
    this._queryShopTrackList()
  },
  methods: {
    addCart(item){
      var user = localStorage.getItem('userInfo')
      if (!user){
        this.$router.push({
          path: '/login'
        })
        return;
      }
      user = JSON.parse(user)
      const form = {
        uid: user.id,
        pid: item.pid,
      }
      addShopCart(form).then(res => {
        if (res.success) {
          this.$toast({
            message: '已添加至购物车',
            duration: 1500
          })
        }
      })
    },
    _queryShopTrackList() {
      let user = JSON.parse(localStorage.getItem("userInfo"))
      const params = {
        uid: user.id
      }
      queryShopTrackList(params).then((res) => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    toDetailed(id) {
      this.$router.push({
        path: 'product/detail',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .recommend-content{
      padding: 10px 12px;
      background: #ffffff;
      .item{
        border:1px solid rgba(243,243,243,1);
        .name{
          height:38px;
          font-size:14px;
          font-weight:bold;
          line-height:19px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
        .footer{
          display: flex;
          justify-content: space-between;
          .price{
            height:30px;
            font-size:16px;
            font-weight:bold;
            line-height:30px;
            color:rgba(254,0,59,1);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/track/index.vue